import React, { useState } from 'react';
import {
    FormControlLabel,
    Switch,
    Tooltip,
    Typography,
    Box,
    IconButton,
} from '@mui/material';

import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const ProjectSettingsSwitches = () => {
    const [billable, setBillable] = useState(true);
    const [disableActivity, setDisableActivity] = useState(false);
    const [disableIdleTime, setDisableIdleTime] = useState(false);

    return (
        <>
            <Box>
                <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ margin: '0px auto 16px' }}>
                    <Typography className="" fontWeight={'600'} sx={{ fontSize: '14px', color: '#1A1F36', fontFamily:'Manrope' }}>Billable</Typography>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={billable}
                                onChange={() => setBillable(!billable)}
                                color="primary"
                                sx={{
                            width: 40,
                            height: 25,
                            padding: 0,
                            '& .MuiSwitch-switchBase': {
                                padding: 0.5,
                                '&.Mui-checked': {
                                    transform: 'translateX(16px)',
                                    color: '#fff',
                                    '& + .MuiSwitch-track': {
                                        backgroundColor: '#E0EEFE',
                                        opacity: 1,
                                        border: '1px solid #0076FE1F',

                                    },
                                    '& .MuiSwitch-thumb': {
                                        backgroundColor: '#0076FE',
                                    }
                                },
                            },
                            '& .MuiSwitch-thumb': {
                                width: 13,
                                height: 13,
                                boxShadow: ' 0 1px 1px #00000040',
                                margin: '2px auto 0',
                            },
                            '& .MuiSwitch-track': {
                                borderRadius: '20px',
                                backgroundColor: '#E5E8EB',
                                opacity: 1,
                                border: '1px solid #D0D5DD',
                            },
                        }}
                            />
                        }
                    />
                </Box>

                <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ margin: '0px auto 16px' }}>
                    <Box>
                        <Typography display="flex" alignItems="center" fontWeight={'600'} sx={{ fontSize: '14px', color: '#1A1F36', lineHeight: '1', margin: '0 auto 2px', fontFamily:'Manrope' }}>Disable Activity
                            <Tooltip title="Disable Activity" arrow placement="top">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon sx={{ fontSize: '12px', margin: '0 0 1px 4px ' }} fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography fontWeight={'400'} sx={{ fontSize: '12px', color: '#64748B', fontFamily:'Manrope' }}>Disables activity tracking for members on call or meeting projects.</Typography>
                    </Box>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={disableActivity}
                                onChange={() => setDisableActivity(!disableActivity)}
                                color="primary"
                                sx={{
                            width: 40,
                            height: 25,
                            padding: 0,
                            '& .MuiSwitch-switchBase': {
                                padding: 0.5,
                                '&.Mui-checked': {
                                    transform: 'translateX(16px)',
                                    color: '#fff',
                                    '& + .MuiSwitch-track': {
                                        backgroundColor: '#E0EEFE',
                                        opacity: 1,
                                        border: '1px solid #0076FE1F',

                                    },
                                    '& .MuiSwitch-thumb': {
                                        backgroundColor: '#0076FE',
                                    }
                                },
                            },
                            '& .MuiSwitch-thumb': {
                                width: 13,
                                height: 13,
                                boxShadow: ' 0 1px 1px #00000040',
                                margin: '2px auto 0',
                            },
                            '& .MuiSwitch-track': {
                                borderRadius: '20px',
                                backgroundColor: '#E5E8EB',
                                opacity: 1,
                                border: '1px solid #D0D5DD',
                            },
                        }}
                            />
                        }
                    />
                </Box>


                <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ margin: '0px auto 16px' }}>
                    <Box>
                        <Typography display="flex" alignItems="center" fontWeight={'600'} sx={{ fontSize: '14px', color: '#1A1F36', lineHeight: '1', margin: '0 auto 2px', fontFamily:'Manrope' }}>
                            Disable Idle Time
                            <Tooltip title="Disable Idle Time" arrow placement="top">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon sx={{ fontSize: '12px', margin: '0 0 1px 4px ' }} fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography fontWeight={'400'} sx={{ fontSize: '12px', color: '#64748B', fontFamily:'Manrope' }}>Disables idle time tracking for projects like calls or meetings.</Typography>
                    </Box>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={disableIdleTime}
                                onChange={() => setDisableIdleTime(!disableIdleTime)}
                                color="primary"
                                sx={{
                            width: 40,
                            height: 25,
                            padding: 0,
                            '& .MuiSwitch-switchBase': {
                                padding: 0.5,
                                '&.Mui-checked': {
                                    transform: 'translateX(16px)',
                                    color: '#fff',
                                    '& + .MuiSwitch-track': {
                                        backgroundColor: '#E0EEFE',
                                        opacity: 1,
                                        border: '1px solid #0076FE1F',

                                    },
                                    '& .MuiSwitch-thumb': {
                                        backgroundColor: '#0076FE',
                                    }
                                },
                            },
                            '& .MuiSwitch-thumb': {
                                width: 13,
                                height: 13,
                                boxShadow: ' 0 1px 1px #00000040',
                                margin: '2px auto 0',
                            },
                            '& .MuiSwitch-track': {
                                borderRadius: '20px',
                                backgroundColor: '#E5E8EB',
                                opacity: 1,
                                border: '1px solid #D0D5DD',
                            },
                        }}
                            />
                        }
                    />
                </Box>
            </Box>
        </>
    );
};

export default ProjectSettingsSwitches;
